import { Table, TableCell, TableHeading } from '@nike/eds'
import { HTMLProps, ReactElement } from 'react'
import { Column, Row, useTable } from 'react-table'
import { TableTitle } from './TableTitle'
import { ExportButton, ExportButtonProps } from '../export/ExportButton'
import './SimpleTable.scss'

export interface SimpleTableProps extends HTMLProps<HTMLDivElement> {
  columns: Column[]
  data: any
  title?: string
  footer?: ReactElement
  exportButton?: ExportButtonProps
  getRowProps?: (props: Row<any>) => object
  compact?: boolean
}

export function SimpleTable({
  columns,
  data,
  title = undefined,
  footer = undefined,
  exportButton = undefined,
  getRowProps = () => ({}),
  compact = false,
  ...otherProps
}: SimpleTableProps) {
  // Use the state and functions returned from useTable to build your UI
  const { headers, rows, getTableProps, getTableBodyProps, prepareRow } = useTable({
    columns,
    data,
    defaultColumn: {
      width: 'auto',
    },
  })

  // Render the UI for your table
  return (
    <div {...otherProps} style={{ overflowX: 'visible' }}>
      {(title || exportButton) && (
        <div className={compact ? 'compact-table-title-row' : 'table-title-row'}>
          {title && <TableTitle title={title} />}
          {exportButton && <ExportButton className="table-export-button" {...exportButton} />}
        </div>
      )}
      <Table isDark={false} {...getTableProps()} style={{ width: '100%' }}>
        <thead>
          <tr>
            {headers.map((column) => {
              return (
                <TableHeading
                  {...column.getHeaderProps({
                    style: {
                      minWidth: column.minWidth,
                      width: column.width,
                      maxWidth: column.maxWidth,
                    },
                  })}
                >
                  {column.Header}
                </TableHeading>
              )
            })}
          </tr>
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot>{footer}</tfoot>
      </Table>
    </div>
  )
}
